import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import About from './paths/About';
import Contact from './paths/Contact';
import Gallery from './paths/Gallery';
import Home from './paths/Home';
import * as React from 'react';
import { HeaderLayout } from './HeaderLayout';
import { WeddingHeaderLayout } from './WeddingHeaderLayout';
import db from './firebase';
import Wedding from './paths/wedding/Wedding';
import RSVP from './paths/wedding/Rsvp';
import { Planning } from './paths/services/Planning';
import { Florals } from './paths/services/Florals';
import { Doc } from './paths/services/Doc';

function App() {
  return (
    <>
      <link href="https://fonts.googleapis.com/css?family=Nunito:300&display=swap" rel="stylesheet" />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=EB+Garamond" />
      <link rel="stylesheet" href="https://fonts.cdnfonts.com/css/arabilla-signature" />

      <BrowserRouter>
        <Switch>
          <WeddingHeaderLayout path={`/wedding`} component={Wedding} />
          <HeaderLayout path={`/gallery`} component={Gallery} />
          <HeaderLayout path={`/about`} component={About} />
          <HeaderLayout path={`/contact`} component={Contact} />
          
          <HeaderLayout path={`/planning`} component={Planning} />
          <HeaderLayout path={`/florals`} component={Florals} />
          <HeaderLayout path={`/doc`} component={Doc} />
          <HeaderLayout component={Home} />
        </Switch>
      </BrowserRouter>

      <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js"
        integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN"
        crossOrigin="anonymous" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.4.1/dist/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossOrigin="anonymous" />

      <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js"
        integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM"
        crossOrigin="anonymous" />
    </>
  );
}

export default App;
